module.exports = __webpack_public_path__ + "static/media/clear.1d143928.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Search/clear.svg
// module id = 1434
// module chunks = 0